import { Workflow } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import type { SpaceHubResponse } from "@/api";
import { SectionEmpty } from "@/components/section";
import { SpaceSection } from "./SpaceSection";
import { WorkflowCard } from "./WorkflowCard";

/**
 * Workflows used in the space (MHS-1011): one card each, with how its last run went and Run. A personal space also
 * shows the owner's workflows that aren't in any space. Building them stays in Build.
 */
export function WorkflowsSection({ space }: Readonly<{ space: SpaceHubResponse }>) {
  const { t } = useTranslation("spaces", { keyPrefix: "detail.workflows" });
  const navigate = useNavigate();
  const items = (space.resources ?? []).filter((r) => r.resourceType === "flow" && r.flow);
  const unplaced = space.unplacedWorkflows ?? [];
  const empty = items.length === 0 && unplaced.length === 0;
  return (
    <SpaceSection
      title={t("title")}
      hint={space.isPersonal ? t("personalHint") : undefined}
      action={
        space.canEdit
          ? { label: t("add"), onClick: () => navigate(`/spaces/${space.uuid}/settings/workflows`) }
          : undefined
      }
    >
      {empty ? (
        <SectionEmpty icon={<Workflow size={18} />} hint={t("empty")} />
      ) : (
        <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2">
          {items.map((item) =>
            item.flow ? <WorkflowCard key={item.uuid} spaceUuid={space.uuid} workflow={item.flow} item={item} /> : null,
          )}
          {unplaced.map((workflow) => (
            <WorkflowCard key={workflow.uuid} spaceUuid={space.uuid} workflow={workflow} />
          ))}
        </div>
      )}
    </SpaceSection>
  );
}
